<template>
  <div class="container">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/termometria/produto/lista' }">Listas de Produtos</el-breadcrumb-item>
          <el-breadcrumb-item>Importação</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Importação de Produtos a partir de um CSV</h1>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <p>{{ getFabricanteNome() }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="permissao.lista_preco_termometria">
        <el-upload action="" :auto-upload="false" :show-file-list="false" accept=".csv" :on-change="handleFileUpload" style="text-align: left; margin-left: 10px;">
          <el-button type="primary">Carregar CSV</el-button>
        </el-upload>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: right;">
        <el-button @click="baixarModeloImportarCSV">Baixar Modelo CSV</el-button>
      </el-col>
    </el-row>
    <el-row v-if="carregandoCSV && tabelaNovos.length == 0 && tabelaEditaveis.length == 0 && tabelaRemovidos.length == 0">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <br/>
        <h3>Nenhum produto para ser importado!</h3>
      </el-col>
    </el-row>
    <el-row v-if="importandoCSV && tabelaNovos.length == 0 && tabelaEditaveis.length == 0 && tabelaRemovidos.length == 0">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <br/>
        <h3>Todos os produtos foram importatos para Lista de Preços de Produtos!</h3>
      </el-col>
    </el-row>
    <div v-if="tabelaNovos.length > 0 || tabelaEditaveis.length > 0 || tabelaRemovidos.length > 0">
      <div>
        <br /><br />
        <span>Início </span>
        <el-date-picker
          v-model="data_inicio"
          type="date"
          format="dd/MM/yy"
          value-format="dd/MM/yy"
          disabled
          placeholder="Selecione a data">
        </el-date-picker>
        <span style="padding-left: 15px;">Fim </span>
        <el-date-picker
          v-model="data_fim"
          type="date"
          format="dd/MM/yy"
          value-format="dd/MM/yy"
          disabled
          placeholder="Selecione a data">
        </el-date-picker>
        <span style="padding-left: 15px;">Validade </span>
        <el-date-picker
          v-model="data_validade"
          type="date"
          format="dd/MM/yy"
          value-format="dd/MM/yy"
          disabled
          placeholder="Selecione a data">
        </el-date-picker>
      </div>
      <div>
        <br />
        <span>Nome da Lista </span>
        <el-input v-model="lista_nome" placeholder="Nome da lista" style="width: 70%;" :disabled="lista_id>0" @input="setNomeListaProdutos"></el-input>
      </div>
    </div>
    <div style="text-align: left; margin-left: 10px;" v-if="tabelaNovos.length > 0">
      <br /><br />
      <el-tooltip class="item" effect="dark" content="Adicionar os produtos que estão no CSV e não estão na tabela" placement="top">
        <el-button type="success" @click="confirmAdd" :loading="loading.add">Adicionar Selecionados</el-button>
      </el-tooltip>
      <br /><br />
    </div>
    <el-table ref="tabelaNovos" :data="tabelaNovos" @selection-change="setSelected('novos', $event)" style="width: 100%" size="mini"  v-if="tabelaNovos.length > 0">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="cod_nbr" label="Cód NBR" width="75"></el-table-column>
      <el-table-column prop="cod_fabricante" label="Cód Fabricante" width="120"></el-table-column>
      <el-table-column prop="nome" label="Nome" width="320"></el-table-column>
      <el-table-column prop="modelo" label="Modelo" width="130"></el-table-column>
      <el-table-column label="Valor" width="90" align="right" header-align="right">
        <template #default="{ row }">
          {{ formatarValor(row.valor) }}
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: left; margin-left: 10px;" v-if="tabelaEditaveis.length > 0">
      <br /><br />
      <el-tooltip class="item" effect="dark" content="Edita as informações dos produtos na tabela que estão diferente no CSV" placement="top">
        <el-button type="warning" @click="confirmUpdate" :loading="loading.update">Atualizar Selecionados</el-button>
      </el-tooltip>
      <br /><br />
    </div>
    <el-table ref="tabelaEditaveis" :data="tabelaEditaveis" @selection-change="setSelected('editaveis', $event)" style="width: 100%" size="mini" v-if="tabelaEditaveis.length > 0">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="cod_nbr" label="Cód NBR" width="75"></el-table-column>
      <el-table-column label="Cód Fabricante" width="120">
        <template #default="{ row }">
          <el-tooltip v-if="row.cod_fabricante !== row.original.cod_fabricante" :content="`Atual: ${row.original.cod_fabricante}`" placement="top">
            <span><b>{{ row.cod_fabricante }}</b></span>
          </el-tooltip>
          <span v-else>{{ row.cod_fabricante }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Nome" width="320">
        <template #default="{ row }">
          <el-tooltip v-if="row.nome !== row.original.nome" :content="`Atual: ${row.original.nome}`" placement="top">
            <span><b>{{ row.nome }}</b></span>
          </el-tooltip>
          <span v-else>{{ row.nome }}</span>
        </template>
      </el-table-column>      
      <el-table-column label="Modelo" width="130">
        <template #default="{ row }">
          <el-tooltip v-if="row.modelo !== row.original.modelo" :content="`Atual: ${row.original.modelo}`" placement="top">
            <span><b>{{ row.modelo }}</b></span>
          </el-tooltip>
          <span v-else>{{ row.modelo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Valor" width="90" align="right" header-align="right">
        <template #default="{ row }">
          <el-tooltip v-if="row.valor !== row.original.valor" :content="`Atual: ${formatarValor(row.original.valor)}`" placement="top">
            <span><b>{{ formatarValor(row.valor) }}</b></span>
          </el-tooltip>
          <span v-else>{{ formatarValor(row.valor) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: left; margin-left: 10px;" v-if="tabelaRemovidos.length > 0">
      <br /><br />
      <el-tooltip class="item" effect="dark" content="Desabilita na tabela produtos que não estão ativos no CSV" placement="top">
        <el-button type="danger" @click="confirmDelete" :loading="loading.delete">Remover Selecionados</el-button>
      </el-tooltip>
      <br /><br />
    </div>
    <el-table ref="tabelaRemovidos" :data="tabelaRemovidos" @selection-change="setSelected('removidos', $event)" style="width: 100%" size="mini" v-if="tabelaRemovidos.length > 0">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="cod_nbr" label="Cód NBR" width="75"></el-table-column>
      <el-table-column prop="cod_fabricante" label="Cód Fabricante" width="120"></el-table-column>
      <el-table-column prop="nome" label="Nome" width="320"></el-table-column>
      <el-table-column prop="modelo" label="Modelo" width="130"></el-table-column>
      <el-table-column label="Valor" width="90" align="right" header-align="right">
        <template #default="{ row }">
          {{ formatarValor(row.valor) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import axios from 'axios';
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      csvDados: [],
      listaProdutos: [],
      tabelaNovos: [],
      tabelaEditaveis: [],
      tabelaRemovidos: [],
      permissao: {},
      usuario: null,
      fabricante_id: null,
      selected: { novos: [], editaveis: [], removidos: [] },
      loading: { update: false, add: false, delete: false },
      carregando: false,
      lista_id: 0,
      lista_nome: '',
      data_inicio: '',
      data_fim: '',
      data_validade: '',
      data_inicio_iso: '',
      data_fim_iso: '',
      data_validade_iso: '',
      carregandoCSV: false,
      importandoCSV: false,
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.editar_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.usuario = FuncoesUteis.getUsuario();
    this.fabricante_id = this.usuario.id_fabricante || 0;
  },
  methods: {
    async handleFileUpload(event) {
      this.carregandoCSV = true
      this.importandoCSV = false
      const file = event.raw;
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (e) => {
        const lines = e.target.result.split('\n').map(line => line.split(';').map(value => value.trim()));
        // console.log('lines', lines);
        if (lines.length < 5) {
          this.$notify({
            title: "Erro",
            message: "O arquivo CSV não tem o formato de linhas suficientes.",
            type: "error"
          })
          return;
        }
        // console.log('Aqui 01A')
        const cliente_cod = parseInt(lines[0][1], 10);
        // console.log('Aqui 01B')
        this.data_inicio = lines[1][1];
        // console.log('Aqui 01C')
        this.data_fim = lines[2][1];
        // console.log('Aqui 01D')
        this.data_validade = lines[3][1];
        // console.log('Aqui 01E')
        this.data_inicio_iso = this.formatarDataParaISO(this.data_inicio);
        // console.log('Aqui 01F')
        this.data_fim_iso = this.formatarDataParaISO(this.data_fim);
        // console.log('Aqui 01G')
        this.data_validade_iso = this.formatarDataParaISO(this.data_validade);
        // console.log('Aqui 01H')
        // console.log('fabricante_id', this.fabricante_id)
        if (cliente_cod !== this.fabricante_id) {
          this.$notify({
            title: "Erro",
            message: "Cliente do CSV não corresponde ao cliente logado.",
            type: "error"
          })
          return;
        }
        // console.log('Aqui 01')
        this.csvDados = lines.slice(6).map(values => {
          if (values.length < 6 || values[0] === "") return null;
          return {
            sge_cliente: cliente_cod,
            cod_nbr: values[0],
            cod_fabricante: values[1],
            nome: values[2],
            modelo: values[3],
            tag: values[4],
            valor: (parseFloat(values[5]?.replace(',', '.') || '0') || 0).toFixed(2),
            ativo: values[6],
            data_inicio: this.data_inicio_iso,
            data_fim: this.data_fim_iso,
            data_validade: this.data_validade_iso,
            lista_nome: this.lista_nome,
          };
        }).filter(item => item !== null && item.ativo === "1");
        // console.log('Aqui 02')
        await this.getListaProdutos()
        // console.log('Aqui 03')
        this.comparaDados(this.csvDados)
        // console.log('Aqui 04')
        this.selecionarTodos()
      };
      reader.readAsText(file);
    },
    async getListaProdutos() {
      try {
        this.carregando = true;
        const params = {
          data_inicio: this.data_inicio_iso,
          data_fim: this.data_fim_iso
        };
        const response = await axios.get(url + "/termometria-produto-lista-importar", {
          params,
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.lista_id = response.data.id;
          this.lista_nome = response.data.nome;
          this.listaProdutos = response.data.produtos;
          this.setNomeListaProdutos(this.lista_nome);
        }
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: "Não foi possível carregar a lista de produtos.",
          type: "error"
        });
      } finally {
        this.carregando = false;
      }
    },
    comparaDados(csvDados) {
      //PRODUTOS NOVOS
      this.tabelaNovos = csvDados.filter(csvItem =>
        !this.listaProdutos.some(dbItem => String(dbItem.cod_nbr).trim() === String(csvItem.cod_nbr).trim())
      );
      //PRODUTOS COM ALTERAÇÕES
      this.tabelaEditaveis = csvDados
      .map(csvItem => {
        const item = this.listaProdutos.find(dbItem => String(dbItem.cod_nbr).trim() === String(csvItem.cod_nbr).trim());
        if (item && (
          String(item.cod_fabricante).trim() !== String(csvItem.cod_fabricante).trim() ||
          String(item.nome).trim() !== String(csvItem.nome).trim() ||
          String(item.modelo).trim() !== String(csvItem.modelo).trim() ||
          parseFloat(item.valor) !== parseFloat(csvItem.valor)
        )) {
          return {
            ...csvItem,
            id: item.produto_lista_preco_id,
            original: {
              cod_fabricante: item.cod_fabricante,
              nome: item.nome,
              modelo: item.modelo,
              valor: item.valor,
              produto_lista_preco_id: item.produto_lista_preco_id,
            }
          };
        }
      })
      .filter(item => item !== undefined);
      //PRODUTOS INEXISTENTES NA LISTA CSV
      this.tabelaRemovidos = this.listaProdutos.filter(dbItem => 
        !csvDados
          .filter(csvItem => csvItem?.cod_nbr)
          .some(csvItem => String(csvItem.cod_nbr).trim() === String(dbItem.cod_nbr).trim())
      );
    },
    setSelected(type, selectedRows) {
      this.selected[type] = selectedRows;
    },
    selecionarTodos() {
      this.$nextTick(() => {
        if (this.$refs.tabelaNovos) {
          this.tabelaNovos.forEach(row => {
            this.$refs.tabelaNovos.toggleRowSelection(row, true);
          });
        }
        if (this.$refs.tabelaEditaveis) {
          this.tabelaEditaveis.forEach(row => {
            this.$refs.tabelaEditaveis.toggleRowSelection(row, true);
          });
        }
        if (this.$refs.tabelaRemovidos) {
          this.tabelaRemovidos.forEach(row => {
            this.$refs.tabelaRemovidos.toggleRowSelection(row, true);
          });
        }
      });
    },
    async confirmAdd() {
      try {
        if (this.lista_id === 0 && this.lista_nome.length < 10) {
          this.$notify({
            title: "Aviso",
            message: "O nome da lista deve ser de pelo menos 10 letras.",
            type: "warning"
          });
          return;
        }
        if (!this.selected.novos || this.selected.novos.length === 0) {
          this.$notify({ title: "Aviso", message: "Nenhum produto selecionado.", type: "warning" });
          return;
        }
        this.loading.add = true
        this.importandoCSV = true
        // console.log("confirmAdd", this.selected.novos);
        const response = await axios.post(url + "/termometria-produto-lista-importar-todos", {produtos: this.selected.novos}, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.carregandoCSV = false;
          this.tabelaNovos = []
        }
        //for (const item of this.selected.novos) {
        //  const response = await axios.post(url+"/termometria-produto-lista-importar", item, {
        //    headers: { Authorization: "Bearer " + this.$store.state.token },
        //  });
        //  if (response.data.status === "Token is Expired") {
        //    await this.$store.dispatch("logout");
        //    this.$router.push("/login");
        //    break;
        //  } else {
        //    this.carregandoCSV = false
        //    let removerCodNbr = item.cod_nbr
        //    this.tabelaNovos = this.tabelaNovos.filter((item) => item.cod_nbr !== removerCodNbr)
        //  }
        //}
        this.$notify({ title: "Sucesso", message: "Produtos adicionados com sucesso!", type: "success" });
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: "Não foi possível adicionar o produto.",
          type: "error"
        });
      } finally {
        this.loading.add = false;
      }
    },
    async confirmUpdate() {
      try {
        if (this.lista_id === 0 && this.lista_nome.length < 10) {
          this.$notify({
            title: "Aviso",
            message: "O nome da lista deve ser de pelo menos 10 letras.",
            type: "warning"
          });
          return;
        }
        if (!this.selected.editaveis || this.selected.editaveis.length === 0) {
          this.$notify({ title: "Aviso", message: "Nenhum produto selecionado.", type: "warning" });
          return;
        }
        this.loading.update = true
        this.importandoCSV = true
        const response = await axios.post(url+"/termometria-produto-lista-importar-todos-2/", {produtos: this.selected.editaveis}, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.carregandoCSV = false
          this.tabelaEditaveis = [];
        }
        // for (const item of this.selected.editaveis) {
        //   const response = await axios.put(url+"/termometria-produto-lista-importar/"+item.original.produto_lista_preco_id, item, {
        //     headers: { Authorization: "Bearer " + this.$store.state.token },
        //   });
        //   if (response.data.status === "Token is Expired") {
        //     await this.$store.dispatch("logout");
        //     this.$router.push("/login");
        //     break;
        //   } else {
        //     this.carregandoCSV = false
        //     let removerID = item.id
        //     this.tabelaEditaveis = this.tabelaEditaveis.filter((item) => item.id !== removerID);
        //   }
        // }
        this.$notify({ title: "Sucesso", message: "Produtos atualizados com sucesso!", type: "success" });
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: "Não foi possível atualizar o produto.",
          type: "error"
        });
      } finally {
        this.loading.update = false;
      }
    },
    async confirmDelete() {
      try {
        if (this.lista_id === 0 && this.lista_nome.length < 10) {
          this.$notify({
            title: "Aviso",
            message: "O nome da lista deve ser de pelo menos 10 letras.",
            type: "warning"
          });
          return;
        }
        if (!this.selected.removidos || this.selected.removidos.length === 0) {
          this.$notify({ title: "Aviso", message: "Nenhum produto selecionado.", type: "warning" });
          return;
        }
        if (!confirm("Tem certeza que deseja excluir os registros selecionados?")) return;
        this.loading.delete = true
        this.importandoCSV = true
        for (const item of this.selected.removidos) {
          const response = await axios.delete(url+"/termometria-produto-lista-importar/"+item.produto_lista_preco_id, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          });
          if (response.data.status === "Token is Expired") {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
            break;
          } else {
            this.carregandoCSV = false
            let removerID = item.id
            this.tabelaRemovidos = this.tabelaRemovidos.filter((item) => item.id !== removerID);
          }
        }
        this.$notify({ title: "Sucesso", message: "Produtos removidos com sucesso!", type: "success" });
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: "Não foi possível remover o produto.",
          type: "error"
        });
      } finally {
        this.loading.delete = false;
      }
    },
    getPayloadFromJWT(token) {
      try {
        const base64Payload = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(base64Payload));
        return decodedPayload;
      } catch (error) {
        this.$notify({
            title: "Erro",
            message: "Erro ao decodificar JWT:", error,
            type: "error"
          })
        return null;
      }
    },
    formatarDataParaISO(data) {
      const partes = data.split('/');
      if (partes.length !== 3) return '';

      let ano = partes[2];
      let mes = partes[1];
      let dia = partes[0];

      if (ano.length === 2) {
        ano = '20' + ano;
      }

      return `${ano}-${mes}-${dia}`;
    },
    formatarDataParaBR(data) {
      const partes = data.split('-');
      if (partes.length !== 3) return '';

      let ano = partes[0];
      let mes = partes[1];
      let dia = partes[2];

      if (ano.length === 2) {
        ano = '20' + ano;
      }

      return `${dia}/${mes}/${ano}`;
    },
    getFabricanteNome() {
      let fabricante_nome = ""
      if (localStorage.getItem('fabricante_nome')!=null) {
        fabricante_nome = '('+localStorage.getItem('ultimo_fabricante')+') '+localStorage.getItem('fabricante_nome')
      }
      return fabricante_nome
    },
    setNomeListaProdutos(nome) {
      this.tabelaNovos = this.tabelaNovos.map(item => ({
        ...item,
        lista_nome: nome
      }));
      this.tabelaEditaveis = this.tabelaEditaveis.map(item => ({
        ...item,
        lista_nome: nome
      }));
      this.tabelaRemovidos = this.tabelaRemovidos.map(item => ({
        ...item,
        lista_nome: nome
      }));
      this.selecionarTodos()
    },
    baixarModeloImportarCSV() {
      const url = '/files/termometria-produtos-importar.csv';
      window.open(url, '_blank');
    },
    formatarValor(valor) {
      if (valor == null) return "0,00";
      return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor);
    },

  }
};
</script>

<style>
.el-table td, .el-table th {
  padding: 0 0;
}
</style>
